export type ClassType<T> = new (...args: any[]) => T;
export type Project<T, S> = (source: T) => S;
export type FieldDecorator = (target: object, propertyKey: string) => void;
export type Callback<T> = (value: T) => void;
export type Predicate<T> = (value: T) => boolean;

export type KeysOfType<T, TType> = keyof {
  [K in keyof T as T[K] extends TType ? (K extends string ? K : never) : never]: T[K] extends TType ? T[K] : never;
};
